export const SIZE_OPTIONS = {
  landscape: [
    {
      value: '16_9',
      label: '16:9',
    },
    {
      value: '4_3',
      label: '4:3',
    },
  ],
  portrait: [
    {
      value: '9_16',
      label: '9:16',
    },
    {
      value: '3_4',
      label: '3:4',
    },
    {
      value: '1_1',
      label: '1:1',
    },
    {
      value: '1_2',
      label: '1:2',
    },
    {
      value: '4_5',
      label: '4:5',
    },
  ],
}

export const RESOLUTION_OPTIONS = {
  '9_16': [
    {
      value: '1080x1920',
      label: '1080 x 1920',
    },
    {
      value: '720x1280',
      label: '720 x 1280',
    },
    {
      value: '750x1334',
      label: '750 x 1334',
    },
  ],
  '3_4': [
    {
      value: '768x1024',
      label: '768 x 1024',
    },
  ],
  '1_1': [
    {
      value: '1080x1080',
      label: '1080 x 1080',
    },
  ],
  '1_2': [
    {
      value: '1080x2160',
      label: '1080 x 2160',
    },
  ],
  '4_5': [
    {
      value: '1024x1280',
      label: '1024 x 1280',
    },
  ],
  '16_9': [
    {
      value: '1920x1080',
      label: '1920 x 1080',
    },
    {
      value: '1280x720',
      label: '1280 x 720',
    },
  ],
  '4_3': [
    {
      value: '1024x768',
      label: '1024 x 768',
    },
  ],
}
